export default __webpack_public_path__ + "static/media/BebasNeue-Regular.7b207e0a.ttf";